import "../scss/app.scss";
import { popper } from '@popperjs/core';
import { ScrollSpy, Tooltip, Dropdown, Popover, Collapse } from "bootstrap";
import Flickity from "flickity";
import AOS from "aos";
import GLightbox from "glightbox";

/* include navigation setup */
import "./inc/navigation.js";

document.addEventListener("DOMContentLoaded", function () {
  var scrollHandler = function () {
    if (window.scrollY === 0) {
      document.body.classList.add("is-scroll-top");
    } else {
      document.body.classList.remove("is-scroll-top");
    }
    if (window.scrollY > 500) {
      document.body.classList.add("far-away");
    } else {
      document.body.classList.remove("far-away");
    }
    document.body.style.setProperty("--scroll-top", Math.round(window.scrollY * 100 / document.documentElement.getBoundingClientRect().height) / 100);
  };
  window.addEventListener("scroll", scrollHandler, { passive: true });
  window.dispatchEvent(new Event("scroll"));

  /* MENU */

  document
    .getElementById("menu_btn")
    .addEventListener("click", function (event) {
      document.body.classList.toggle("menu_active");
    }, { passive: true });
  document
    .getElementById("close_menu_btn")
    .addEventListener("click", function (event) {
      document.body.classList.toggle("menu_active");
    }, { passive: true });

  var menu_links = document.querySelectorAll(
    ".main-menu > ul > li.menu-item-has-children > a"
  );
  for (const menu_item of menu_links) {
    menu_item.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      var current = document.querySelector('.main-menu .selected');
      if (current) {
        current.classList.remove('selected');
      }
      menu_item.parentNode.classList.toggle("selected");
      var activerub = document.querySelector('.main-menu > ul > li.selected');
      if (activerub) {
        document.querySelector('.main-menu > ul > li.selected > .sub-menu > li:first-child').classList.add('activerub');
        document.querySelector("body").classList.add("menu_active");

        var activeMenu = document.querySelector('.main-menu > ul > li.selected > .sub-menu > li > .sub-menu');
        if (activeMenu) {
          var menuHeight = (menuHeight < 120) ? 120 : activeMenu.offsetHeight;
          document.querySelector(".main-menu > ul > li.selected > .sub-menu").style.cssText = '--submenuHeight:' + menuHeight + 'px';
        }
      } else {
        document.querySelector("body").classList.remove("menu_active");
      }
      return false;
    }, { passive: true });
  }

  document.querySelector(".modal").addEventListener("click", function () {
    for (const menu_item of menu_links) {
      menu_item.parentNode.classList.remove("selected");
    }
    document.querySelector("body").classList.remove("menu_active");
  }, { passive: true });

  var menu_sublinks = document.querySelectorAll(
    ".main-menu > ul > li.menu-item-has-children > .sub-menu > li.menu-item-has-children > a"
  );
  for (const menu_item of menu_sublinks) {

    menu_item.parentNode.addEventListener("mouseover", (e) => {
      document.querySelector(".main-menu > ul > li.selected > .sub-menu > li:first-child").classList.remove('activerub');
      menu_item.parentNode.classList.add("activerub");
      var menuHeight = menu_item.parentNode.querySelector('.sub-menu').offsetHeight;
      if (menuHeight < 120) {
        menuHeight = 120;
      }
      document.querySelector(".main-menu > ul > li.selected > .sub-menu").style.cssText = '--submenuHeight:' + menuHeight + 'px';
    }, { passive: true });
    menu_item.parentNode.addEventListener("mouseout", (e) => {
      menu_item.parentNode.classList.remove("activerub");
      document.querySelector(".main-menu > ul > li.selected > .sub-menu > li:first-child").classList.add('activerub');
      var activeMenu = document.querySelector('.main-menu > ul > li.selected > .sub-menu > li > .sub-menu');
      if (activeMenu) {
        var menuHeight = (menuHeight < 120) ? 120 : activeMenu.offsetHeight;
        document.querySelector(".main-menu > ul > li.selected > .sub-menu").style.cssText = '--submenuHeight:' + menuHeight + 'px';
      }
    }, { passive: true });

    menu_item.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }, { passive: true });
  }


  /*
    var filter_selector = document.querySelector(".filter_header select");
    if (filter_selector) {
      filter_selector.addEventListener("change", function () {
        document.location = filter_selector.value;
      });
    }
  */
  /* FIN MENU */
  window.addEventListener('scroll', scrollNavigation, false)
  function scrollNavigation() {
    const elements = document.querySelectorAll('.summary')
    const navHeight = 110
    elements.forEach((el) => {
      //let elSpied = el.parentNode.parentNode.querySelector('.text_content, .the_content');
      let elSpied = document.querySelector('.text_content, .the_content')
      if (el.parentElement.getBoundingClientRect().top <= navHeight && el.parentElement.getBoundingClientRect().bottom >= elSpied.getBoundingClientRect().bottom) {
        el.classList.add('scroll-navigation-fixed')
        el.classList.remove('scroll-navigation-bottom')
        el.style.cssText = 'width:' + (el.parentNode.getBoundingClientRect().width - 30) + 'px;';
      } else {
        el.classList.remove('scroll-navigation-fixed')
      }

      if ((el.getBoundingClientRect().top + el.getBoundingClientRect().height + navHeight) >= (el.parentElement.getBoundingClientRect().top + el.parentElement.getBoundingClientRect().height + navHeight)) {
        el.classList.add('scroll-navigation-bottom')
      } else {
        el.classList.remove('scroll-navigation-bottom')
      }
    }, { passive: true })
  }

  var iframes = document.querySelectorAll(".video-section iframe");
  for (const iframe of iframes) {
    console.log("ts0");
    iframe.parentNode.classList.add("ratio");
    iframe.parentNode.classList.add("ratio-16x9");
  }

  var galleryElems = document.querySelectorAll(".cards-slider");
  for (var i = 0, len = galleryElems.length; i < len; i++) {
    var galleryElem = galleryElems[i];
    new Flickity(galleryElem, {
      cellAlign: "center",
      autoPlay: false,
      pageDots: false,
      groupCells: false,
      wrapAround: true,
      initialIndex: 2
    });
  }

  var galleryElems = document.querySelectorAll(
    ".articles_section .slider_container"
  );
  for (var i = 0, len = galleryElems.length; i < len; i++) {
    var galleryElem = galleryElems[i];
    new Flickity(galleryElem, {
      cellAlign: "center",
      autoPlay: false,
      pageDots: false,
      groupCells: false,
      wrapAround: false,
      initialIndex: 2
    });
  }

  function checkWrap(carouselSelector = '.carousel', cellSelector = '.carousel-cell') {
    // if sum(carousel-cell width) > carousel width then wrap else not
    const carousel = document.querySelector(carouselSelector);
    const cells = carousel.querySelectorAll(cellSelector);

    if (carousel && cells) {
      let cellsTotalWidth = 0;
      cells.forEach((cell) => {
        const style = window.getComputedStyle(cell);
        cellsTotalWidth += parseFloat(style.width) +
          parseFloat(style.marginRight) +
          parseFloat(style.marginLeft);
      });
      const carouselWidth = parseFloat(window.getComputedStyle(carousel).width);
      return cellsTotalWidth > carouselWidth;
    }

    return false;
  }

  var galleryElems = document.querySelectorAll(
    ".partner_slider_section .partners-slider"
  );
  for (var i = 0, len = galleryElems.length; i < len; i++) {
    var galleryElem = galleryElems[i];
    new Flickity(galleryElem, {
      cellAlign: "center",
      autoPlay: true,
      pageDots: false,
      groupCells: false,
      wrapAround: checkWrap(".partner_slider_section .partners-slider"),
      draggable: true,
      prevNextButtons: false,
      initialIndex: 2,
      pauseAutoPlayOnHover: false,
      autoPlay: 2500,
      /*selectedAttraction: 0.01,
      friction: 0.1*/
    });
  }

  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new Tooltip(tooltipTriggerEl)
  });

  AOS.init({
    duration: 500,
    easing: "ease",
    once: true,
    offset: 120,
  });

  const lightbox = GLightbox({
    touchNavigation: true,
    loop: true,
    autoplayVideos: true,
  });
  const lightbox_content = GLightbox({
    selector: '.gallery-item a',
    touchNavigation: true,
    loop: true,
    autoplayVideos: true,
  });

}, { passive: true });


/*
var menu_links = document.querySelectorAll(
  "#primary-menu > li.menu-item-has-children > a, #primary-menu > li.menu-item-has-children.selected > ul.sub-menu > li.menu-item-has-children > a"
);

for (const menu_item of menu_links) {
  menu_item.addEventListener("click", (e) => {
    console.log(e);
    menu_item.parentNode.classList.toggle("selected");
    let is_active = false;
    for (const main_item of menu_links) {
      if (menu_item != main_item) {
        main_item.parentNode.classList.remove("selected");
      }
      if (main_item.parentNode.classList.contains("selected")) {
        is_active = true;
      }
    }
    if (is_active) {
      document.querySelector("body").classList.add("menu_active");
    } else {
      if (
        !document
          .getElementById("site-navigation")
          .classList.contains("toggled")
      ) {
        document.querySelector("body").classList.remove("menu_active");
      }
    }
    e.preventDefault();
    e.stopPropagation();
    return false;
  });
}
*/
if (document.querySelector("#chapters:not(.static)")) {
  var scrollSpy = new ScrollSpy(document.body, {
    target: "#chapters",
    offset: 180,
  });
}

var chapter_selector = document.querySelector("#chapter_selector select");
if (chapter_selector) {
  chapter_selector.addEventListener("change", function () {
    var url = location.href;
    location.href = chapter_selector.value;
    history.replaceState(null, null, url);
  }, { passive: true });
}

var triggerEvent = function (elem, event) {
  var evt = new MouseEvent(event, {
    bubbles: true,
    cancelable: true,
    view: window,
  });
  var canceled = !elem.dispatchEvent(evt);
};

/*
var search_btn = document.querySelector("a.search_btn");
if (search_btn) {
  search_btn.addEventListener("click", function () {
    var modal = document.querySelector(".modal_search");
    document.getElementById("search_input").focus();
    modal.classList.toggle("active");
  });
  document
    .querySelector(".modal_search .modal")
    .addEventListener("click", function () {
      var modal = document.querySelector(".modal_search");
      modal.classList.toggle("active");
    });
  document
    .querySelector(".modal_search .close_btn")
    .addEventListener("click", function () {
      var modal = document.querySelector(".modal_search");
      modal.classList.toggle("active");
    });
}
*/